
















import { Component, Vue, Prop } from 'vue-property-decorator';

import TextField from '@/components/Form/TextField.vue';
import UmiaRoles from '@/components/Staff/UserManagement/Roles/UmiaRoles.vue';

@Component({
	name: 'NewInvite',
	components: {
		TextField,
		UmiaRoles,
	},
})
export default class NewInvite extends Vue {
	@Prop() private user: any;
	@Prop() private deleteUser: any;
	@Prop() private index: any;
}
